import Map from "./components/map.js";
import Menu from "./components/menu.js";
import Legend from "./components/legend.js";

export default function App() {
  return (
    <div>
      <Menu />
      <Legend />
      <Map />
    </div>
  );
}
